import ShopAutoId from '@/utils/firebase-storage-manager/models/ShopAutoId'
import LocalStorageManager from '@/utils/local-storage-manager'

export function fetchLocalWaitlist (rId: string): ShopAutoId | undefined {
  const shopAutoIds = new LocalStorageManager().userWaitlists
  return shopAutoIds.find(shop => shop.restaurantId === rId)
}
